import { Button, Form, Modal } from "react-bootstrap"
import i18next from "i18next"
import _ from 'lodash';
import { useState } from "react";
import RequiredFormLabel from "../RequiredFormLabel/RequiredFormLabel";

type Props = {
  isOpen?: boolean;
  closeModal?: (reload?: boolean) => void;
  doRejectUser: (reason: string) => void;
}

export function RejectUserModal({ isOpen, doRejectUser, closeModal = _.noop }: Props) {
  const [reason, setReason] = useState('');

  const onClose = () => {
    setReason('');
    closeModal();
  }

  return (
    <Modal show={isOpen}>
      <Modal.Header>
        <Modal.Title className='display-6'>{i18next.t('confirm')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {i18next.t('reject_user_confirmation_message')}
        <Form>
          <Form.Group className="mb-3 mt-3">
            <RequiredFormLabel label={i18next.t('reason_for_reporter_rejection')} />
            <Form.Control required as="textarea" rows={3} onChange={(e) => setReason(e?.target?.value)} />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='link' onClick={onClose}>
          {i18next.t('cancel')}
        </Button>
        <Button disabled={!reason?.trim()} onClick={() => doRejectUser(reason)}>
          {i18next.t('confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
